var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sdz-modal",
    {
      ref: "sdzModal",
      attrs: {
        title: _vm.modalTitle,
        "confirm-button-label": "Salvar",
        "confirmation-event": "saveConfiguration",
        "cancel-event": "cancelConfiguration",
        width: "550",
        persistent: "",
        "custom-class": "default-sheet-modal",
        "buttons-position": "right",
        "close-icon": "",
      },
      on: {
        close: _vm.close,
        saveConfiguration: _vm.saveConfiguration,
        cancelConfiguration: _vm.cancelConfiguration,
      },
    },
    [
      [
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("p", [
              _vm._v(
                "\n        Realize a configuração das colunas que serão exibidas no"
              ),
              _c("br"),
              _vm._v(
                "\n        template e defina quais campos são obrigatórios durante o"
              ),
              _c("br"),
              _vm._v("\n        preenchimento.\n        "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n        As colunas desabilitadas não poderão ser alteradas.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "options" }, [
              _c("span", [_vm._v("Colunas")]),
              _vm._v(" "),
              _c("span", [_vm._v("Tornar obrigatório")]),
            ]),
            _vm._v(" "),
            _vm._l(_vm.sheetOptions, function (option, index) {
              return _c(
                "div",
                { key: index, staticClass: "list-content" },
                [
                  _c("AppCheckBox", {
                    attrs: {
                      options: [{ title: option.label, value: false }],
                      disabled: !option.editable,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setCheckboxValue(option)
                      },
                    },
                    model: {
                      value: option.checkbox,
                      callback: function ($$v) {
                        _vm.$set(option, "checkbox", $$v)
                      },
                      expression: "option.checkbox",
                    },
                  }),
                  _vm._v(" "),
                  _c("AppSwitch", {
                    attrs: { disabled: !option.editable },
                    on: {
                      change: function ($event) {
                        return _vm.setSwitchValue(option)
                      },
                    },
                    model: {
                      value: option.switch,
                      callback: function ($$v) {
                        _vm.$set(option, "switch", $$v)
                      },
                      expression: "option.switch",
                    },
                  }),
                ],
                1
              )
            }),
          ],
          2
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }